import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import { priceTransform } from '@vsf-enterprise/commercetools';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useCartPreview } from '@/composables/useCheckout/modules/useCartPreview';
export default {
  name: 'ProgressBar',
  props: {
    maxPriceObject: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useCartPreview = useCartPreview(),
      discountedSubtotal = _useCartPreview.discountedSubtotal;
    var centDiscountedSubtotal = computed(function () {
      return discountedSubtotal.value * 100;
    });
    var currentLimit = computed(function () {
      var centAmounts = props.maxPriceObject.map(function (rate) {
        return rate.centAmount;
      }).sort(function (a, b) {
        return a - b;
      });
      var index = 0;
      for (var i = 0; i < centAmounts.length; i++) {
        if (centAmounts[i] > centDiscountedSubtotal.value) {
          index = i;
          break;
        }
      }
      return props.maxPriceObject[index];
    });
    var thresholdPrice = computed(function () {
      var _currentLimit$value;
      return ((_currentLimit$value = currentLimit.value) === null || _currentLimit$value === void 0 ? void 0 : _currentLimit$value.centAmount) || 0;
    });
    var remainingAmount = computed(function () {
      var _currentLimit$value2, _currentLimit$value3;
      return centDiscountedSubtotal.value >= thresholdPrice.value ? priceTransform(0, ((_currentLimit$value2 = currentLimit.value) === null || _currentLimit$value2 === void 0 ? void 0 : _currentLimit$value2.currencyCode) || null) : priceTransform((thresholdPrice.value - centDiscountedSubtotal.value) / 100, ((_currentLimit$value3 = currentLimit.value) === null || _currentLimit$value3 === void 0 ? void 0 : _currentLimit$value3.currencyCode) || null);
    });
    var progressAmount = computed(function () {
      return parseFloat((centDiscountedSubtotal.value / thresholdPrice.value * 100).toFixed(2));
    });
    return {
      translate: translate,
      thresholdPrice: thresholdPrice,
      progressAmount: progressAmount,
      remainingAmount: remainingAmount,
      currentLimit: currentLimit
    };
  }
};